import DataProvider from "../DataProvider";

async function fetchAllRecords(start = 0, records = []) {
  const perPage = 100;
  const { data } = await DataProvider.getList("alerttypes", {
    pagination: { page: start / perPage + 1, perPage },
    sort: { field: "event_type", order: "ASC" },
    filter: {},
  });
  const allRecords = records.concat(data);
  //if the number of records fetched is equal to the perPage, fetch the next page
  if (data.length === perPage) {
    return fetchAllRecords(start + perPage, allRecords);
  }
  return allRecords;
}

async function AlertTypes() {
  return fetchAllRecords(); // Start fetching from the beginning
}

export { AlertTypes };
